module.exports = __webpack_public_path__ + "static/media/jardinero.b1841223.png";